import { render, staticRenderFns } from "./SelectTenantPage.vue?vue&type=template&id=6f7faf50"
import script from "./SelectTenantPage.vue?vue&type=script&lang=js"
export * from "./SelectTenantPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports